import React from 'react'
import styles from './styles.css'
import PaymentsIcon from './payments.svg'
import ProcessIcon from './process.svg'
import SelectInstallments from './select-installments.svg'
import AfterpayLogo from './afterpay-logo.svg'

import { Modal } from '@deal/components'

interface Props {
  onClose: () => void
  isOpen: boolean
}

const AfterPayModal: React.SFC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} className={styles.modal} onRequestClose={onClose}>
      <div className={styles.close} onClick={onClose} />
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.installments}>Installments by</div>
          <div>
            <AfterpayLogo width={215} />
          </div>
          <div className={styles.blueHeader}>Shop now. Enjoy now. Pay later.</div>
          <div className={styles.interestHeader}>
            4 interest-free payments, every two weeks, at checkout
          </div>
        </div>

        <div className={styles.bullets}>
          <div className={styles.bullet}>
            <SelectInstallments className={styles.bulletIcon} />
            <div className={styles.bulletHeader}>
              Select Installments by Afterpay as your payment method
            </div>
            <div className={styles.bulletBody}>Use your existing payment card</div>
          </div>
          <div className={styles.bullet}>
            <ProcessIcon className={styles.bulletIcon} />
            <div className={styles.bulletHeader}>Complete your checkout</div>
            <div className={styles.bulletBody}>No long forms, approval decision online</div>
          </div>
          <div className={styles.bullet}>
            <PaymentsIcon className={styles.bulletIcon} />
            <div className={styles.bulletHeader}>Pay over 4 equal payments</div>
            <div className={styles.bulletBody}>
              Enjoy your purchase right away! Pay every two weeks with zero interest and no fees
              when you pay on time.
            </div>
          </div>
        </div>

        <div className={styles.legal}>
          To see Afterpay's complete terms and conditions, visit{' '}
          <a
            href="https://www.afterpay.com/purchase-payment-agreement"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://www.afterpay.com/purchase-payment-agreement
          </a>
        </div>
      </div>
    </Modal>
  )
}

export default AfterPayModal
